import React from 'react'
import clsx from "clsx";

import { APP_COLOR } from '../AtomsGlobalProps'
import { HEADER_LEVEL, PageHeaderProps} from "./PageHeaderProps";

import './PageHeader.scss'


/**
 * ATOM – Komponent headera komponentu/ pagea SVG, Obsługuje aria-label i aria-hidden
 *
 * @param {String} title - Tekst nagłówka.
 * @param {Boolean} line - Informacja czy po bokach nagłówka ma znajdować się dekoracyjna linia.
 */
const PageHeader = (props: PageHeaderProps) => {
    const { title, line, className, align = "left", level = HEADER_LEVEL.H1, color = APP_COLOR.ACCENT, ...rest } = props;

    const classes = clsx(line && "with-line", className, `app-color--${color.toLowerCase()}`, `page-header--align-${align.toLocaleLowerCase()}`)


    const Tag =
        level === HEADER_LEVEL.H1 ? "h1" :
            level === HEADER_LEVEL.H2 ? "h2" :
                level === HEADER_LEVEL.H3 ? "h3" :
                    "h4";

    return (
        <Tag {...rest}
             className={classes} dangerouslySetInnerHTML={{__html: title}}>
        </Tag>
    )

}
export default PageHeader